import { createSelector } from 'reselect';
import { searchParameterSelector } from './SearchParameter.Selectors';

const modelsSelector = store => store.SearchParameter.models.input;
const modelMapSelector = store => store.SearchParameter.modelMap;
const instanceSizeSelector = store => store.Evaluation.instanceSize;
const evaluationCategorySelector = store => store.Evaluation.evaluationCategorySn;

/* eslint-disable */
export const evaluationParameterSelector = createSelector(
  modelsSelector,
  modelMapSelector,
  instanceSizeSelector,
  evaluationCategorySelector,
  searchParameterSelector,
  (
    models,
    modelMap,
    instanceSize,
    evaluationCategorySn,
    {
      source,
      category,
      camera,
      batch,
      // imageSN,
      // imageSize,
      // evaluatedImageFilter,
      // categoryMap,
      // sourceMap,
      // batchMap
    }
  ) => {
    const result = {
      eval_umbo_category_sn: evaluationCategorySn
    };

    if (instanceSize) {
      Object.assign(result, { instance_size: instanceSize });
    }

    if (models.length) {
      const transformedModel = models.map(name => modelMap.get(name));
      Object.assign(result, { models: transformedModel });
    }

    if (source) {
      Object.assign(result, { source_sn: source });
    }
    if (camera) {
      Object.assign(result, { camera_id: camera });
    }
    if (batch) {
      Object.assign(result, { batch_sn: batch });
    }
    if (category) {
      // Object.assign(result, { umbo_category_sn: category });
      // Remove default value after handling empty metrics
      Object.assign(result, { umbo_category_sn: 1 });
    }

    return result;
  }
);


// WEBPACK FOOTER //
// ./src/selectors/EvaluationSelector.js